import { render, staticRenderFns } from "./EditFrontDesk.vue?vue&type=template&id=3de2874b&scoped=true"
import script from "./EditFrontDesk.vue?vue&type=script&lang=js"
export * from "./EditFrontDesk.vue?vue&type=script&lang=js"
import style0 from "./EditFrontDesk.vue?vue&type=style&index=0&id=3de2874b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de2874b",
  null
  
)

export default component.exports